<script>
import { defineAsyncComponent } from "vue";
import { componentStore } from "@common/componentStore/componentStore";
import { ddStore } from "@common/ddStore";
import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";

const vmsAffiliationManagerConfig = {
    cId: "vmsAffiliationManager",
    cType: "vmsAffiliationManager",
    cTitle: "Affiliation Manager",
    cTemplate: `<div class="vms-affiliation-manager" :id="'vmsAffiliationManagerWrapper' + cId">
                    <div class="vms-affiliation-manager-affiliate-area">
                        <div class="vms-affiliation-manager-left">
                            <condensed-filter
                                v-if="!loading"
                                :cId="'condensedFilter__addAffiliation' + cId"
                                :ref="'affiliationsListManagerFilter' + cId"
                                :prop-filter-options="filterOptions"
                                :prop-filter-items="recordList"
                                :prop-result="filteredItems"
                                :prop-additional-config="filterAdditionalConfig"
                                @update:prop-result="filteredItems = $event"
                                :prop-filtering=false
                                @update:prop-filtering="filtering = $event"
                                :prop-item-label="'Organization(s)'"
                            ></condensed-filter>
                        </div>
                        <div class="vms-affiliation-manager-right">
                            <control name="BUTTON_GRID_SETTINGS"></control>
                        </div>
                        <div class="vms-affiliation-manager-right">
                            <control name="BUTTON_AFFILIATE"></control>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <div class="vms-affiliation-manager-grid-area">
                        <div class="vms-affiliation-manager-left">
                            <grid
                                :c-id="'grid__affiliationsList' + cId"
                                ref="affiliationsListManagerGrid"
                                @update:data-bound="affiliationsListDataBound($event)"
                                :prop-data="affiliationList"
                                :prop-settings="gridSettings"
                                :prop-selected-items="selectedItems"
                                @update:prop-selected-items="selectedItems = $event;"
                                :prop-selected-items-full-data="selectedItemsFullData"
                                @update:prop-selected-items-full-data="selectedItemsFullData = $event; disableButtons()"
                                :prop-row-bound-func="affRowBoundFunc"
                                :prop-row-selecting-func="affRowSelectingFunc"

                            ></grid>
                        </div>
                        <div class="vms-affiliation-manager-right">
                            <div class="vms-affiliation-manager-grid-controls">
                                <control name="BUTTON_EDIT"></control>
                            </div>
                            <div class="vms-affiliation-manager-grid-controls">
                                <control name="BUTTON_HISTORY"></control>
                            </div>
                            <div class="vms-affiliation-manager-grid-controls">
                                <control name="BUTTON_DELETE"></control>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'BUTTON_AFFILIATE',
            type: 'button',
            label: 'Affiliate',
            onclick: 'affiliate'
        },
        {
            name: 'BUTTON_GRID_SETTINGS',
            type: 'button',
            label: 'Grid Settings',
            onclick: 'editGridSettings'
        },
        {
            name: 'BUTTON_EDIT',
            type: 'button',
            label: 'Edit',
            onclick: 'edit',
            disabled: true
        },
        {
            name: 'BUTTON_HISTORY',
            type: 'button',
            label: 'History',
            onclick: 'openHistory',
            disabled: true
        },
        {
            name: 'BUTTON_DELETE',
            type: 'button',
            label: 'Unaffiliate',
            onclick: 'delete',
            disabled: true
        },
    ]
};

const editorSettings = {
    managerMode: {
        type: 'dropdown',
        label: 'Affiliation Manager Mode',
        items: [
            { text: 'Vol Org', value: 'vol_org' },
            { text: 'Vol Activity', value: 'vol_ae' },
            { text: 'Org Org', value: 'org_org' },
            { text: 'From Props', value: 'from_props' }
        ],
        fields: {
            text: 'text',
            value: 'value'
        },
        default: 'from_props'
    }
};

let vmsAffiliationManagerCmp = {
    name: 'vmsAffiliationManager',
    editorSettings,
    props: {
        affiliationManagerMode: {
            default: 'vol_org' /* possible values: 'vol_org', 'vol_ae', 'vol_org' */
        },

    },
    data() {
        return {
            currentRecordId: 0,
            selectedRecordIds: [],
            filteredItems: {},
            recordList: {},
            affiliationList: {},
            selectedItems: {},
            selectedItemsFullData: {},
            gridSettingsSelectedItems: {},
            gridSettingsSelectedItemsFullData: {},
            gridSettingsSelectedItemsIndexes: [],
            gridSettings: {
                "paging": false,
                "sorting": true,
                "filtering": false,
                "grouping": false,
                "resizing": true,
                "width": '100%',
                "height": '310px',
                "enableCheckBox": true,
                "clipMode": "EllipsisWithTooltip",
            },
            orgKindsList: [],
            affInfo: [],
            affID: 0,
            affGridFieldList: {
                headers: [],
                records: []
            },
            affGridFieldListSelected: ['ORG_TITLE'],
            filterAdditionalConfig: {
                allowCustomValue: false,
                allowFiltering: true,
                filterType: 'Contains',
                showResultsAfterFiltersApplied: true,
                notShowMissingOptions: true,
                additionalValues: ['ORG_KIND']
            },
            customFilterOptions: {},
            currentRecordKind: false,
            loading: true
        };
    },
    computed: {
        filterOptions() {
            if (this.managerMode !== 'vol_ae') {
                return {
                    ...{
                        RECORD_TITLE: {
                            label: 'All Organizations',
                            placeholder: 'Start typing to affiliate',
                            exactMatch: true,
                            fields: { text: 'text', value: 'RECORD_ID' },
                            itemTemplate: `<div class="vms-affiliation-manager-item-template-wrapper">
                            <div class="vms-affiliation-manager-item-template-text">{{data.text}}</div>
                            <div class="vms-affiliation-manager-item-template-tag" v-if="data && data.additionalValue && data.additionalValue.ORG_KIND">
                                <div class="vms-affiliation-manager-item-template-kind-tag">{{data.additionalValue.ORG_KIND}}</div>
                            </div>
                        </div>`
                        },
                        RECORD_ID: {
                            label: 'Organization ID', placeholder: 'Start typing to affiliate', exactMatch: true
                        }
                    },
                    ...this.customFilterOptions
                };
            }

            return {
                ...{
                    RECORD_TITLE: {
                        label: 'All Activities',
                        placeholder: 'Start typing to affiliate',
                        exactMatch: true,
                        fields: { text: 'text', value: 'RECORD_ID' },
                        itemTemplate: `<div class="vms-affiliation-manager-item-template-wrapper">
                        <div class="vms-affiliation-manager-item-template-text">{{data.text}}</div>
                        <div class="vms-affiliation-manager-item-template-tag" v-if="data && data.additionalValue && data.additionalValue.ORG_KIND">
                            <div class="vms-affiliation-manager-item-template-kind-tag">{{data.additionalValue.ORG_KIND}}</div>
                        </div>
                    </div>`
                    }
                },
                ...this.customFilterOptions
            };
        },
        managerMode() {
            return (!this.config || !this.config.managerMode || this.config.managerMode === 'from_props')
                ? this.affiliationManagerMode // from props
                : this.config.managerMode;
        }
    },
    methods: {
        async onLoad() {
            ddStore.preloadGroup('COMMON');
            // eslint-disable-next-line camelcase
            if (typeof profile_getFormObject === 'function') {
                let theForm = profile_getFormObject();
                if (theForm && theForm.recordID) {
                    this.currentRecordId = theForm.recordID.value;
                    // eslint-disable-next-line camelcase
                    if (typeof SmartTabs === 'object' && typeof general_resizeToContent === 'function') {
                        general_resizeToContent(1, 0, 5);
                    }
                }
            }
            if (!this.currentRecordId) {
                if (this.managerMode !== 'vol_org' && this.orgId) this.currentRecordId = this.orgId;
                else if (this.managerMode === 'vol_org' && this.volId) this.currentRecordId = this.volId;
            }
            library.showLoadingIndicator('vmsAffiliationManagerWrapper' + this.cId);
            await this.getAffiliationAttributes();
            await this.getRecordsLists();
            library.hideLoadingIndicator('vmsAffiliationManagerWrapper' + this.cId);
            this.loading = false;
        },
        affiliationsListDataBound(isPreparingData) {
            this.$nextTick(() => {});
        },
        async getAffiliationAttributes() {
            let getAttrList = [];
            if (this.managerMode === 'org_org' && !this.currentRecordKind) {
                getAttrList.push('org_kind');
            }
            // get all data by one request
            if (getAttrList.length) {
                await configStore.getAttrList(getAttrList);
                if (this.managerMode === 'org_org' && !this.currentRecordKind) {
                    let tmpOrgKinds = await configStore.getAttrList(['org_kind']);
                    for (let i in tmpOrgKinds) {
                        if (i === 'length') continue;
                        this.orgKindsList[this.orgKindsList.length] = { text: library.cloneObj(tmpOrgKinds[i]), value: parseInt(i, 10) };
                    }
                }
            }
        },
        async getRecordsLists() {
            let response = await this.sDs.post('ec_affiliationManagerGetData', this.managerMode, this.currentRecordId);
            if (response.status === 'success' && response.data) {
                this.recordList = [];
                if (this.$refs
                    && this.$refs['affiliationsListManagerFilter' + this.cId]
                    && typeof this.$refs['affiliationsListManagerFilter' + this.cId].clearAllFilters === 'function'
                ) {
                    this.$refs['affiliationsListManagerFilter' + this.cId].clearAllFilters();
                }
                if (response.data['currentRecordKind']) {
                    this.currentRecordKind = parseInt(response.data['currentRecordKind'], 10);
                }
                if (response.data['recordList']) {
                    let tmpRecordList = response.data['recordList'];
                    if (this.managerMode === 'org_org') {
                        let tmpCustomFilterOptions = {};
                        let filteredOrgKindsList = [];
                        if (this.currentRecordKind > 0 && this.currentRecordKind < 1000) {
                            filteredOrgKindsList = this.orgKindsList.filter((tmpOrgKind) => (tmpOrgKind.value > 1000));
                        } else if (this.currentRecordKind > 1000 && this.currentRecordKind < 2000) {
                            filteredOrgKindsList = this.orgKindsList.filter((tmpOrgKind) => (tmpOrgKind.value < 1000));
                        } else {
                            filteredOrgKindsList = this.orgKindsList;
                        }
                        if (filteredOrgKindsList.length) {
                            for (let tmpI in tmpRecordList) {
                                if (tmpRecordList[tmpI]['ORG_KIND']) {
                                    let tmpCustomFilterOptionName = tmpRecordList[tmpI]['ORG_KIND'].toUpperCase().replaceAll(' ', '_');
                                    tmpRecordList[tmpI][tmpCustomFilterOptionName] = tmpRecordList[tmpI]['RECORD_TITLE'];
                                }
                            }
                            for (let tmpJ in filteredOrgKindsList) {
                                let tmpCustomFilterOption = library.cloneObj(this.filterOptions['RECORD_TITLE']);
                                tmpCustomFilterOption.fields = { text: 'RECORD_TITLE', value: 'RECORD_ID' };
                                tmpCustomFilterOption.label = filteredOrgKindsList[tmpJ].text;
                                let tmpCustomFilterOptionName = filteredOrgKindsList[tmpJ].text.toUpperCase().replaceAll(' ', '_');
                                tmpCustomFilterOptions[tmpCustomFilterOptionName] = tmpCustomFilterOption;
                            }
                        }
                        this.customFilterOptions = tmpCustomFilterOptions;
                    }
                    this.recordList = tmpRecordList;
                }
                this.affiliationList = {};
                if (response.data['affiliationList']) {
                    this.affiliationList = {};
                    let affiliationList = {
                        headers: [],
                        records: []
                    };
                    if (response.data['gridColumnsList']) {
                        let colWidth = Math.ceil(620 / response.data['gridColumnsList'].length);
                        for (let i in response.data['gridColumnsList']) {
                            if (i === 'length') continue;
                            let outputName = library.cloneObj(response.data['gridColumnsList'][i]['displayTitle']);
                            outputName = outputName.split('::').length > 1 ? outputName.split('::')[1] : outputName;
                            affiliationList.headers.push({
                                text: outputName,
                                field: library.cloneObj(response.data['gridColumnsList'][i]['COL_NAME']),
                                width: colWidth,
                                allowSorting: !response.data['gridColumnsList'][i]['MULTIPLE']
                            });
                        }
                    } else {
                        affiliationList.headers.push({
                            text: 'Organization',
                            field: 'RECORD_TITLE',
                            width: 660,
                        });
                    }
                    if (affiliationList.headers.length) {
                        this.gridSettings['sortSettings'] = {
                            columns: [
                                {
                                    field: affiliationList.headers[0].field,
                                    direction: 'Ascending'
                                }
                            ]
                        };
                    }
                    let affIds = [];
                    for (let i in response.data['affiliationList']) {
                        if (i === 'length') continue;
                        let tmp = library.cloneObj(response.data['affiliationList'][i]);
                        tmp['RECORD_TITLE'] = library.cloneObj(tmp['RECORD_TITLE']);
                        tmp['rowID'] = tmp['AFFILIATION_ID'];
                        affiliationList.records.push(tmp);
                        affIds.push(tmp['AFFILIATION_ID']);
                    }
                    this.affiliationList = library.cloneObj(affiliationList);
                    if (affIds.length) {
                        let subscriptionDetail = this.recordStore.subscribe({
                            source: 'sds_getProfileField',
                            params: {
                                recordId: affIds,
                                recordPsp: 'aff',
                                params: { strictTypeResults: true }
                            },
                            updateFrequency: 0,
                        },
                        this.cId,
                        true);
                        // TODO double check this (probably should move to computed model using subscription and getSubscription()
                        this.$watch('recordStore.subscriptions.' + subscriptionDetail.key + '.lastRequestTime', () => {
                            this.getRecordsLists();
                        });
                    }
                }
            }
        },
        disableButtons() {
            if (this.controls) {
                this.controls['BUTTON_EDIT'].disabled = true;
                this.controls['BUTTON_HISTORY'].disabled = true;
                this.controls['BUTTON_DELETE'].disabled = true;
                if (this.selectedItems.length === 1) {
                    this.controls['BUTTON_EDIT'].disabled = false;
                    this.controls['BUTTON_HISTORY'].disabled = false;
                }
                if (this.selectedItems.length >= 1) {
                    this.controls['BUTTON_DELETE'].disabled = false;
                }
            }
        },
        async affiliate() {
            this.selectedRecordIds = [];
            if (this.filteredItems) {
                for (let i in this.filteredItems) {
                    if (i === 'length') continue;
                    this.selectedRecordIds.push(this.filteredItems[i].RECORD_ID);
                }
            }
            if (this.managerMode === 'org_org') {
                await this.sDs.post('sds_createAffiliation', null, this.selectedRecordIds, false, this.currentRecordId);
            } else if (this.managerMode === 'vol_org') {
                await this.sDs.post('sds_createAffiliation', this.currentRecordId, this.selectedRecordIds);
            } else if (this.managerMode === 'vol_ae') {
                for (let i in this.selectedRecordIds) {
                    if (i === 'length') continue;
                    let recordParts = this.selectedRecordIds[i].split('_');
                    if (recordParts && recordParts.length === 2) {
                        // eslint-disable-next-line
                        await this.sDs.post('sds_affiliateVolWithOrgActivities', recordParts[0], this.currentRecordId, recordParts[1]);
                    }
                }
            }
            this.getRecordsLists();
        },
        openHistory() {
            let payload = {
                contextRecordId: this.selectedItems[0],
                component: {}
            };
            actionStore.openAffiliationHistory(payload, this);
        },
        async editGridSettings() {
            // init self to be used in template
            let self = this;
            if (this.affGridFieldList.records.length === 0) {
                // function to process results of sds_getAvailableFields call
                let editGridSettingsPrepareList = (affGridFieldList, data) => {
                    for (let i in data) {
                        if (i === 'length') continue;
                        if (i === 'AFF_NOTE') continue;
                        let tmp = library.cloneObj(data[i]);
                        tmp['COL_NAME'] = library.cloneObj(tmp['displayTitle']);
                        tmp['rowID'] = i;
                        affGridFieldList.push(tmp);
                    }
                    return affGridFieldList;
                };
                // init grid contents array
                this.affGridFieldList = {
                    headers: [],
                    records: []
                };
                this.affGridFieldList.headers.push({
                    text: 'Select the fields to be displayed',
                    field: 'COL_NAME'
                });
                let response;
                // retrieve list of affiliation grid fields
                response = await this.sDs.post('sds_getAvailableFields', 32);
                if (response.status === 'success' && response.data) {
                    this.affGridFieldList.records = editGridSettingsPrepareList(this.affGridFieldList.records, response.data);
                }
                // retrieve list of organization grid fields
                response = await this.sDs.post('sds_getAvailableFields', 3);
                if (response.status === 'success' && response.data) {
                    this.affGridFieldList.records = editGridSettingsPrepareList(this.affGridFieldList.records, response.data);
                }
            }
            if (this.affGridFieldList.records.length > 0) {
                // retrieve list of selected columns, and get indexes
                let response = await this.sDs.post('er_getEcUserProperty', 'vmsAffiliationManager_' + this.managerMode + '_gridList');
                if (response.status === 'success' && response.data) {
                    let tmpAffGridFieldListSelected = library.cloneObj(response.data);
                    this.affGridFieldListSelected = tmpAffGridFieldListSelected.split(',').length > 1 ? tmpAffGridFieldListSelected.split(',') : [tmpAffGridFieldListSelected];
                } else {
                    this.affGridFieldListSelected = ['ORG_TITLE'];
                }
                this.gridSettingsSelectedItemsIndexes = [];
                // cycle through list to get indexes
                for (let i in this.affGridFieldListSelected) {
                    let tmpIdx = 0;
                    for (let j in this.affGridFieldList.records) {
                        if (this.affGridFieldList.records[j].rowID === this.affGridFieldListSelected[i]) {
                            this.gridSettingsSelectedItemsIndexes.push(tmpIdx);
                            break;
                        }
                        tmpIdx++;
                    }
                }
                // grid settings window template
                let tmpUniqueID = self.cId + '_' + library.getUniqueID();
                let vmsAffiliationManagerGridSettingsTemplate = {
                    name: "vmsAffiliationManager-gridSettings-popup_" + tmpUniqueID,
                    template: `
                        <div class="vms-affiliation-manager-gridSettings">
                            <div class="vms-affiliation-manager-edit-status">
                                <grid
                                    :c-id="'grid__gridColumnsList' + this.outer_cId"
                                    ref="affiliationsListManagerGridSettingsGrid"
                                    @update:data-bound="gridSettingsDataBound($event)"
                                    :prop-data="affGridFieldList"
                                    :prop-settings="gridSettings"
                                    :prop-selected-items="selectedItems"
                                    @update:prop-selected-items="selectedItems = $event;"
                                    :prop-selected-items-full-data="selectedItemsFullData"
                                    @update:prop-selected-items-full-data="selectedItemsFullData = $event; optionChanged()"
                                ></grid>
                            </div>
                        </div>
                    `,
                    data() {
                        return {
                            outer_cId: tmpUniqueID,
                            affGridFieldList: self.affGridFieldList,
                            gridSettings: self.gridSettings,
                            selectedItemsIndexes: self.gridSettingsSelectedItemsIndexes,
                            selectedItems: self.gridSettingsSelectedItems,
                            selectedItemsFullData: self.gridSettingsSelectedItemsFullData,
                            controls: {},
                        };
                    },
                    mounted() {},
                    methods: {
                        gridSettingsDataBound(isPreparingData) {
                            this.$nextTick(() => {
                                if (this.$refs
                                    && this.$refs['affiliationsListManagerGridSettingsGrid']
                                    && this.$refs['affiliationsListManagerGridSettingsGrid'].$refs
                                    && this.$refs['affiliationsListManagerGridSettingsGrid'].$refs['grid__gridColumnsList' + this.outer_cId]
                                    && this.$refs['affiliationsListManagerGridSettingsGrid'].$refs['grid__gridColumnsList' + this.outer_cId].ej2Instances
                                    && typeof this.$refs['affiliationsListManagerGridSettingsGrid'].$refs['grid__gridColumnsList' + this.outer_cId].ej2Instances.selectRows === 'function'
                                ) {
                                    this.$refs['affiliationsListManagerGridSettingsGrid'].$refs['grid__gridColumnsList' + this.outer_cId].ej2Instances.selectRows(this.selectedItemsIndexes);
                                }
                            });
                        },
                        optionChanged() {
                            self.gridSettingsSelectedItemsFullData = this.selectedItemsFullData;
                        },
                    },
                    updated() {},
                    components: {
                        control: defineAsyncComponent(() => import('@common/control/control.vue')),
                    },
                };
                let funcOnSuccess = () => {
                    if (this.gridSettingsSelectedItemsFullData.length > 5) {
                        library.showDialog('Please choose no more than 5 columns', false, false, { title: 'Error', showAsAlert: true });
                        return false;
                    }
                    let columnsList = [];
                    for (let i in this.gridSettingsSelectedItemsFullData) {
                        if (i === 'length') continue;
                        columnsList[columnsList.length] = this.gridSettingsSelectedItemsFullData[i].rowID;
                    }
                    this.sDs.post('er_setEcUserProperty', 'vmsAffiliationManager_' + this.managerMode + '_gridList', columnsList.join(',')).then((response) => {
                        if (response.status === 'success') {
                            this.getRecordsLists();
                        }
                    });
                    return true;
                };
                let funcOnFailure = () => {};
                let opt = {
                    title: 'Grid Settings',
                    name: 'vmsAffiliationManagerGridSettingsTemplateDialog',
                    preventCloseOnBackdropClick: false,
                    // size: 'fullscreen',
                    doNotCloseOnOK: false,
                    showCloseIcon: true,
                    closeOnEscape: true,
                    doNotCloseOnFuncFailure: true
                };
                library.showDialog(vmsAffiliationManagerGridSettingsTemplate, funcOnSuccess, funcOnFailure, opt);
            }
        },
        async edit() {
            if (this.selectedItems.length !== 1) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                let msg = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_EMPTY_3', 'affiliation');
                library.showDialog(msg, false, false, { title: title, showAsAlert: true });
                return;
            }
            await actionStore.editAffiliation({ affID: this.selectedItemsFullData[0].AFFILIATION_ID });
            this.getRecordsLists();
        },
        async delete() {
            if (this.selectedItems.length) {
                let affListToDelete = [];
                for (let i in this.selectedItemsFullData) {
                    if (i === 'length') continue;
                    affListToDelete[affListToDelete.length] = this.selectedItemsFullData[i].AFFILIATION_ID;
                }
                if (affListToDelete.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE_THE_TITLE');
                    let message = '';
                    if (affListToDelete.length === 1) {
                        message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE', 'affiliation');
                    } else {
                        message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_MULTIDELETE', 'affiliations');
                    }
                    library.showDialog(message, async () => {
                        await this.sDs.post('sds_deleteAffiliation', affListToDelete);
                        this.getRecordsLists();
                    }, false, { title: title });
                }
            }
        },
        affRowBoundFunc(t, args) {
            if (args.data.IS_READONLY === 1) {
                args.row.classList.add('e-disabled');
            }
        },
        affRowSelectingFunc(t, args) {
            if (args.data.IS_READONLY === 1) {
                args.cancel = true;
            }
            if (args.rowIndexes.length > 1) {
                let index = [];
                args.rowIndexes.filter((rowIndex) => {
                    if (t.$refs[t.ref].getRowByIndex(rowIndex).classList.contains('e-disabled')) {
                        index.push(rowIndex);
                    }
                    return index;
                });
                index.forEach((p) => args.rowIndexes.splice(args.rowIndexes.indexOf(p), 1));
            }
        }
    }
};

componentStore.initComponent(vmsAffiliationManagerCmp, vmsAffiliationManagerConfig);
export { vmsAffiliationManagerCmp, vmsAffiliationManagerConfig };
export default vmsAffiliationManagerCmp;

</script>

<style scoped>
.vms-affiliation-manager {
    padding: 5px;
    width: 790px;
}
.vms-affiliation-manager-grid-controls {
    padding: 5px;
}
.vms-affiliation-manager-grid-controls .control {
    margin-top: -5px;
    margin-right: 5px;
}
.vms-affiliation-manager-left {
    float: left;
}
.vms-affiliation-manager-right {
    float: right;
}
.vms-affiliation-manager-affiliate-area {
    width: 690px;
}
.vms-affiliation-manager-affiliate-area .vms-affiliation-manager-left {
    width: 440px;
}
.vms-affiliation-manager-affiliate-area .vms-affiliation-manager-right {
    margin-top: 7px;
    padding-left: 5px;
}
.vms-affiliation-manager .left-controls > div, .right-controls > div {
    display: inline-block;
}
.vms-affiliation-manager .clearfix {
    clear: both;
}
.vms-affiliation-manager-grid-area .vms-affiliation-manager-left {
    width: 690px;
}

:deep(.vms-affiliation-manager .filter-status) {
    display: none;
}
:deep(.vms-affiliation-manager .e-columnheader  *) {
    background-color: #cfd8dc !important;
    color: black !important;
    border-color: #757575 !important;
}
:deep(.vms-affiliation-manager .e-columnheader  .e-rhandler) {
    border-right-color: white !important;
    border-right-style: dashed !important;
}
:deep(.vms-affiliation-manager .e-headercelldiv) {
    text-align: left !important;
}
:deep(.vms-affiliation-manager .e-gridheader) {
    background-color: #cfd8dc !important;
}
</style>

<style>
.vms-affiliation-manager-item-template-wrapper {
    display: table;
}
.vms-affiliation-manager-item-template-text {
    width: 100%;
    text-wrap: wrap;
    text-indent: 0px;
    padding-left: 16px;
}
.vms-affiliation-manager-item-template-text, .vms-affiliation-manager-item-template-tag {
    display: table-cell;
}
.vms-affiliation-manager-item-template-tag {
    vertical-align: middle;
}
.vms-affiliation-manager-item-template-kind-tag {
    background-color: #e8e2e7;
    color: #484848;
    text-align: center;
    height: fit-content;
    width: fit-content;
    font-size: smaller;
    padding: 3px;
    line-height: normal;
    display: block;
    text-indent: 0px;
}

.vms-affiliation-manager-item-template-kind-tag:empty
{
    display:none;
}

.no-kind-message {
    line-height: 40px;
}
</style>
